import { AwsConfig } from '../Constants';
import BaseService, { RequestInterface } from '../Base';
import { graphqlOperation } from 'aws-amplify';




export default class TicketService extends BaseService {

    constructor(){
        super(AwsConfig.API_CONFIG, 'graphql');
    }

    async createTicket({ scheduleId, processValue, processId }: { scheduleId: string, processValue: any, processId: string }) {
        const createTicket = `mutation createTicket($data: TicketInput!) {
            createTicket(data: $data)
        }`;

        const TicketInput = {
            scheduleId,
            processValue,
            processId
        }

        const query = graphqlOperation(createTicket, {data: TicketInput});

        const params: RequestInterface = { body: query };

        const rest = await super.postGraphQl('', params);
        return rest;
    }
}